import React, { useState } from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Select, Space, message } from 'antd';
import "./close_order.css";
import { closeSalesOrder } from "../../utils/sales";
import { useAuth } from "../../context/AuthContext";


interface CloseOrderProps {
    onClose?: () => void;
    seNo?: string;
}

const CloseOrder: React.FC<CloseOrderProps> = ({
    onClose = () => { },
    seNo = () => { }
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { userData } = useAuth();

    const handleSubmit = async (values: { close_order_reason: any; }) => {
        try {
            setLoading(true);
            const selectedReason = closeOrderReasons.find(r => r.value === values.close_order_reason);
            const reasonLabel = selectedReason ? selectedReason.label : '';
            const requestBy = userData?.kode_grup1 || '';
            await closeSalesOrder(seNo, values.close_order_reason, reasonLabel, requestBy);
            message.success('Order closed successfully');
            onClose();
        } catch (error) {
            message.error('Failed to close order');
        } finally {
            setLoading(false);
        }
    };

    const closeOrderReasons = [
        { value: "", label: "-- Empty --" },
        { value: "01", label: "Less Stock" },
        { value: "02", label: "Overpriced" },
        { value: "03", label: "Change Document" }
    ];

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="i2pmo">
                <div className="gjs-grid-column" id="i8zp6">
                    <Breadcrumb
                        items={[
                            {
                                title: (
                                    <>
                                        <span>Confirmation</span>
                                    </>
                                ),
                            },
                            {
                                title: "Close Order",
                            },
                        ]}
                    />
                </div>
            </div>

            {/* Grid Row 2 */}
            <div className="gjs-grid-row" id="i0lf9">
                <div className="gjs-grid-column" id="i5bx8">
                    {/* Form Horizontal */}
                    <Form
                        form={form}
                        onFinish={handleSubmit}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '180px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                    >
                        <Form.Item
                            label="Close Order Reason"
                            name="close_order_reason"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Please select a reason' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Close Order Reason"
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                options={closeOrderReasons}
                                popupClassName="close-order-dropdown"
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Space style={{ paddingTop: "20px" }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                            >
                                OK
                            </Button>
                            <Button
                                type="primary"
                                onClick={onClose}
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                }}
                            >
                                Cancel
                            </Button>
                        </Space>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default CloseOrder;
